import React from "react";
import { PROCESS_STEPS } from "@/constants/brand";

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl">
          <p className="uppercase text-xs tracking-[0.22em] font-bold text-[#0055FF]">
            The Infolocus Process
          </p>
          <h2 className="font-display mt-4 text-4xl md:text-5xl tracking-tight font-bold text-[#0B1120] leading-tight">
            A 4‑step engagement designed to de‑risk the journey.
          </h2>
        </div>

        <div className="mt-14 md:mt-20 relative">
          <div className="hidden md:block absolute top-[42px] left-0 right-0 h-px bg-[#E2E8F0]" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-0">
            {PROCESS_STEPS.map((step, i) => (
              <div
                key={step.n}
                data-testid={`process-step-${step.n}`}
                className={`relative md:px-8 ${
                  i !== 0 ? "md:border-l border-[#E2E8F0]" : ""
                }`}
              >
                <div className="flex items-center gap-4 md:block">
                  <div className="h-14 w-14 md:h-[84px] md:w-[84px] flex items-center justify-center bg-[#1B2A6E] text-white font-display font-black text-xl md:text-2xl rounded-sm relative z-10">
                    {step.n}
                  </div>
                  <h3 className="font-display text-xl md:text-2xl font-bold text-[#0B1120] md:mt-6">
                    {step.title}
                  </h3>
                </div>
                <p className="mt-4 text-[15px] text-[#475569] leading-relaxed">
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
